const TOOLTIP_CLASS_NAMES = {
  visible: 'tool-tip__content--visible',
  animating: 'tool-tip__content--animating',
}

class Tooltip extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.contentNode = this.querySelector('.tool-tip__content');
    if (!this.contentNode) {
      return;
    }
    this.addEventListener('focusout', this.hide.bind(this));

    this.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch') {
        return;
      }
      this.show();
    });
    this.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') {
        return;
      }
      this.hide();
    });
    this.addEventListener('click', this.toggle.bind(this));
    window.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  disconnectedCallback() {
    window.removeEventListener('click', this.handleOutsideClick);
  }

  show() {
    const visibleTooltips = document.querySelectorAll(`.${TOOLTIP_CLASS_NAMES.visible}`);
    const outerMargin = 20;
    visibleTooltips.forEach((tooltip) => {
      tooltip.classList.remove(TOOLTIP_CLASS_NAMES.visible);
    });

    this.contentNode.classList.add(TOOLTIP_CLASS_NAMES.animating);
    const bodyRect = document.body.getBoundingClientRect();
    const contentRect = this.contentNode.getBoundingClientRect();
    this.contentNode.style.width = `${bodyRect.width - contentRect.left - outerMargin}px`;
    
    window.setTimeout(() => {
      this.contentNode.classList.remove(TOOLTIP_CLASS_NAMES.animating);
      this.contentNode.classList.add(TOOLTIP_CLASS_NAMES.visible);
    }, 10);
  }

  hide() {
    this.contentNode.classList.remove(TOOLTIP_CLASS_NAMES.visible);
  }

  toggle() {
    if (this.contentNode.classList.contains(TOOLTIP_CLASS_NAMES.visible)) {
      this.hide();
    } else {
      this.show();
    }
  }

  handleOutsideClick(event) {
    const insideTooltip = event.target.closest('.tool-tip');
    if (!insideTooltip) {
      this.hide();
    }
  }
}

customElements.define('tool-tip', Tooltip);
